import { Measurand } from "../../../../utils/backend-types";

const order: { [key: string]: number } = {
  [Measurand.positive]: 1,
  [Measurand.negative]: 2,
  [Measurand.reactiveInductive]: 3,
  [Measurand.reactiveCapacitive]: 4
};

export function getSeriesOrderByMeasurand(
  seriesIdA: string,
  seriesIdB: string
): number {
  const measurandA = seriesIdA.split(".")[2];
  const measurandB = seriesIdB.split(".")[2];

  if (!order[measurandA] || !order[measurandB]) {
    return 0;
  }

  return (order[measurandA] || 0) - (order[measurandB] || 0);
}
